import React, { useEffect} from "react";
import { TextField, Grid, Box, Typography} from "@mui/material";
import OffSpe from "./dynamicInputList";

export default function DonForm(props) {

    useEffect(()=>{}, [props.offSpe_fede, props.offSpe_local])

    return(
        <Box>
            <Typography sx={{marginBottom:'15px'}}>Don*: </Typography> 
            <Grid container columnSpacing={2} rowSpacing={2} >
                <Grid item sm={6}>
                    <TextField
                    fullWidth
                    name="dime"
                    label="Dîme (en €)"
                    inputProps={{step:"0.01", min:'0'}}
                    type="number"
                    value={props.dime.toFixed(2)}
                    onChange={(e)=>{if(!isNaN(Number(e.target.value))){
                        props.setTotal(old => Number((old-props.dime+Number(e.target.value)).toFixed(2)))
                        props.setDime(Number(Number(e.target.value).toFixed(2)))
                    }}}/>
                </Grid>
                <Grid item sm={6}>
                    <TextField
                    fullWidth
                    name="offrande globale"
                    label="Offrande Globale (en €)"
                    inputProps={{step:"0.01", min:'0'}}
                    type="number"
                    value={props.off_global.toFixed(2)}
                    onChange={(e)=>{if(!isNaN(Number(e.target.value))){
                        props.setTotal(old => Number((old-props.off_global+Number(e.target.value)).toFixed(2)))
                        props.setOff_global(Number(Number(e.target.value).toFixed(2)))
                    }}}/>
                </Grid>
                {props.offSpeLabel_fede.length>0 &&<Grid item sm={6}>
                    <Typography sx={{margin:'0 0 15px 20px', textAlign:'center', fontWeight:'bold'}}>Offrandes spécifiées FÉDÉRALES</Typography> 
                    <OffSpe
                    eglise={props.eglise}
                    label="Offrande spécifiée (fédéral)"
                    offSpeLabel={props.offSpeLabel_fede}
                    offSpe={props.offSpe_fede}
                    setOffSpe={props.setOffSpe_fede}
                    setOffSpeLabel={props.setOffSpeLabel_fede}
                    setTotal={props.setTotal}
                    canAdd={JSON.parse(sessionStorage.getItem('eglise'))?.isFederation}/>
                </Grid>}
                <Grid item sm={6}>
                    {!JSON.parse(sessionStorage.getItem('eglise'))?.isFederation &&
                    <Typography sx={{margin:'0 0 15px 20px', textAlign:'center', fontWeight:'bold'}}>Offrandes spécifiées LOCALES</Typography> }
                    {!JSON.parse(sessionStorage.getItem('eglise'))?.isFederation && <OffSpe
                    eglise={props.eglise}
                    label="Offrande spécifiée (Local)"
                    offSpeLabel={props.offSpeLabel_local}
                    offSpe={props.offSpe_local}
                    setOffSpe={props.setOffSpe_local}
                    setOffSpeLabel={props.setOffSpeLabel_local}
                    setTotal={props.setTotal}
                    canAdd={props.offSpeLabel_local.length<5}/>}
                </Grid>
            </Grid>
            <Typography sx={{fontWeight:'bold'}}>Total: {props.total.toFixed(2)}€</Typography> 
        </Box>
    )
}